var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkingDays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .working-days-e, .working-days-f, .working-days-g {\r\n        fill: none;\r\n      }\r\n\r\n      .working-days-f, .working-days-g {\r\n        stroke: #45484a;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .working-days-g {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "working-days-e",
    width: 28,
    height: 28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "working-days-f",
    x1: 6.43,
    y1: 17.39,
    x2: 6.43,
    y2: 24.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "working-days-f",
    d: "M5.77,11.12c-.67.12-1.23.59-1.46,1.24h0s-.08,3.44-.08,3.44c-.02.98.51,1.39,2.14,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "working-days-g",
    d: "M9.79,7.36c.04.42-.06,1.42-.28,1.8-.19.33-.64.65-1.13.76-.24.03-.3.03-.54,0-.49-.11-.94-.43-1.13-.76-.22-.38-.32-1.38-.28-1.8.08-.81.83-1.21,1.67-1.21s1.6.4,1.67,1.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "working-days-g",
    d: "M12.49,6.92c1.27-1.28,3.03-2.07,4.97-2.07,3.87,0,7,3.13,7,7s-3.13,7-7,7c-1.8,0-3.44-.68-4.68-1.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "working-days-g",
    points: "19.95 10.61 17.62 12.94 14.11 9.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "working-days-f",
    x1: 17.47,
    y1: 17.47,
    x2: 17.47,
    y2: 16.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "working-days-f",
    x1: 17.47,
    y1: 6.65,
    x2: 17.47,
    y2: 5.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "working-days-f",
    x1: 22.53,
    y1: 11.7,
    x2: 23.24,
    y2: 11.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "working-days-f",
    x1: 10,
    y1: 17.39,
    x2: 10,
    y2: 24.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "working-days-f",
    d: "M10.66,11.12c.67.12,1.23.59,1.46,1.24h0s.08,3.44.08,3.44c.02.98-.51,1.39-2.14,1.51"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingDays);
export default __webpack_public_path__ + "static/media/working-days.a64725262a980efc2a3614354f6fc77f.svg";
export { ForwardRef as ReactComponent };